"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUsersRequestState = exports.fetchUsers = void 0;

var _DynoUtils = require("lead-flows-ui/utils/DynoUtils");

var fetchUsers = function fetchUsers(state) {
  return (0, _DynoUtils.getUsersRequiredAttributes)(state.users.usersList);
};

exports.fetchUsers = fetchUsers;

var getUsersRequestState = function getUsersRequestState(state) {
  return state.users.fetchRequestState;
};

exports.getUsersRequestState = getUsersRequestState;